import React, { createContext, useContext, ReactNode } from 'react';
import { useActivityTracker } from '@/hooks/useActivityTracker';

interface ActivityTrackingContextType {
  trackCustomActivity: (action: string, data?: Record<string, any>) => void;
}

const ActivityTrackingContext = createContext<ActivityTrackingContextType | null>(null);

export const useActivityTracking = () => {
  const context = useContext(ActivityTrackingContext);
  if (!context) {
    // Return a no-op function if not in provider context
    return {
      trackCustomActivity: () => {}
    };
  }
  return context;
};

interface ActivityTrackingProviderProps {
  children: ReactNode;
}

export const ActivityTrackingProvider: React.FC<ActivityTrackingProviderProps> = ({ children }) => {
  const { trackCustomActivity } = useActivityTracker();

  const value = {
    trackCustomActivity
  };

  return (
    <ActivityTrackingContext.Provider value={value}>
      {children}
    </ActivityTrackingContext.Provider>
  );
}; 